export const AVAILABLE_STOCK = 'AVAILABLE_STOCK';
export const LIMITED_STOCK = 'LIMITED_STOCK';
export const OUT_OF_STOCK = 'OUT_OF_STOCK';
